import {
  Card,
  CardAction,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const MandatorySsoFallback = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Skeleton className="h-5.5 w-30 mb-1" />
        </CardTitle>
        <CardAction>
          <Skeleton className="h-9 w-20" />
        </CardAction>
        <CardDescription>
          <Skeleton className="h-5.5 w-250" />
        </CardDescription>
      </CardHeader>
    </Card>
  )
}
